import { BaseCommand } from '../../commands/ICommand';

/**
 * Lightweight command wrapper for view-rules state mutations.
 * Used to keep assistant panel actions within the command pipeline.
 */
export class ViewRulesMutationCommand extends BaseCommand {
  private readonly doMutation: () => void;
  private readonly undoMutation?: () => void;

  constructor(
    name: string,
    doMutation: () => void,
    undoMutation?: () => void,
  ) {
    super(name, undefined, { skipHistory: true });
    this.doMutation = doMutation;
    this.undoMutation = undoMutation;
  }

  execute(): void {
    this.doMutation();
  }

  undo(): void {
    if (this.undoMutation) {
      this.undoMutation();
    }
  }

  canUndo(): boolean {
    return !!this.undoMutation;
  }
}

export default ViewRulesMutationCommand;
